import PropTypes from 'prop-types'

import Badge, {atomBadgeSizes as badgesSizes} from '@s-ui/react-atom-badge'

import {BADGES_CLASS} from '../config.js'

const GalleryBasicBadges = ({badges}) => {
  return (
    <ul className={BADGES_CLASS}>
      {badges.map(({icon: Icon, label, size = badgesSizes.LARGE, type, design}) => {
        const hasIcon = Boolean(Icon)
        return <Badge icon={hasIcon && <Icon />} key={label} label={label} size={size} type={type} design={design} />
      })}
    </ul>
  )
}

GalleryBasicBadges.displayName = 'GalleryBasicBadges'
GalleryBasicBadges.propTypes = {
  badges: PropTypes.array
}

export default GalleryBasicBadges
